import type { ReleaseNote } from './releaseNotes';

export const generatedAppVersion = '0.1.233';
const generatedReleaseNotes: ReleaseNote[] = [
  {
    version: '0.1.233',
    date: '2026-10-13',
    commit: '277024a',
    repository: 'Frontend',
    title: 'Merge pull request #10 from Incloud-Tecnologia/feature/gcp-projecao-mes-corrente-ia-copy',
    category: 'IA',
    description: 'Frontend: Merge pull request #10 from Incloud-Tecnologia/feature/gcp-projecao-mes-corrente-ia-copy.'
  },
  {
    version: '0.1.233',
    date: '2026-10-13',
    commit: '0853c0d',
    repository: 'Frontend',
    title: 'feat: diferenciar projecao de IA vs linear no card "Mes Atual" do GCP',
    category: 'IA',
    description: 'Frontend: feat: diferenciar projecao de IA vs linear no card "Mes Atual" do GCP.'
  },
  {
    version: '0.1.233',
    date: '2026-10-06',
    commit: 'ea27847',
    repository: 'Frontend',
    title: 'fix: Media Mensal e Custo Total tambem usam valor bruto quando ha credito AWS',
    category: 'IA',
    description: 'Frontend: fix: Media Mensal e Custo Total tambem usam valor bruto quando ha credito AWS.'
  },
  {
    version: '0.1.233',
    date: '2026-10-06',
    commit: 'e4c09a9',
    repository: 'Frontend',
    title: 'Merge pull request #8 from Incloud-Tecnologia/fix/inventario-table-espaco-vazio',
    category: 'IA',
    description: 'Frontend: Merge pull request #8 from Incloud-Tecnologia/fix/inventario-table-espaco-vazio.'
  },
  {
    version: '0.1.233',
    date: '2026-10-06',
    commit: '7e23557',
    repository: 'Frontend',
    title: 'fix: espaco em branco ao lado das tabelas de inventario/servicos',
    category: 'Frontend',
    description: 'Frontend: fix: espaco em branco ao lado das tabelas de inventario/servicos.'
  },
  {
    version: '0.1.233',
    date: '2026-10-06',
    commit: 'c386022',
    repository: 'Frontend',
    title: 'Merge pull request #7 from Incloud-Tecnologia/fix/custo-bruto-label-mes-fechado',
    category: 'IA',
    description: 'Frontend: Merge pull request #7 from Incloud-Tecnologia/fix/custo-bruto-label-mes-fechado.'
  },
  {
    version: '0.1.233',
    date: '2026-10-06',
    commit: '0d15f12',
    repository: 'Frontend',
    title: 'docs: corrigir comentario do card Custo Bruto apos fix de mes parcial no backend',
    category: 'IA',
    description: 'Frontend: docs: corrigir comentario do card Custo Bruto apos fix de mes parcial no backend.'
  },
  {
    version: '0.1.233',
    date: '2026-09-25',
    commit: '6d88fa2',
    repository: 'Frontend',
    title: 'Merge pull request #6 from Incloud-Tecnologia/fix/hide-gross-cost-card-gcp',
    category: 'IA',
    description: 'Frontend: Merge pull request #6 from Incloud-Tecnologia/fix/hide-gross-cost-card-gcp.'
  },
  {
    version: '0.1.233',
    date: '2026-09-25',
    commit: 'a11d161',
    repository: 'Frontend',
    title: 'fix: restringir card \'Custo Bruto (antes de creditos)\' a AWS',
    category: 'Frontend',
    description: 'Frontend: fix: restringir card \'Custo Bruto (antes de creditos)\' a AWS.'
  },
  {
    version: '0.1.233',
    date: '2026-09-24',
    commit: 'daeab4e',
    repository: 'Frontend',
    title: 'Merge pull request #5 from Incloud-Tecnologia/feature/dashboard-clarity-fixes',
    category: 'IA',
    description: 'Frontend: Merge pull request #5 from Incloud-Tecnologia/feature/dashboard-clarity-fixes.'
  },
  {
    version: '0.1.233',
    date: '2026-09-24',
    commit: '881a5e6',
    repository: 'Frontend',
    title: 'fix: esconder diagnostico interno de IA do cliente + renomear label confusa',
    category: 'IA',
    description: 'Frontend: fix: esconder diagnostico interno de IA do cliente + renomear label confusa.'
  },
  {
    version: '0.1.233',
    date: '2026-09-24',
    commit: '8ffee02',
    repository: 'Frontend',
    title: 'Merge pull request #4 from Incloud-Tecnologia/feature/admin-users-tenant-select',
    category: 'IA',
    description: 'Frontend: Merge pull request #4 from Incloud-Tecnologia/feature/admin-users-tenant-select.'
  },
  {
    version: '0.1.233',
    date: '2026-09-24',
    commit: '6e7d87f',
    repository: 'Frontend',
    title: 'fix: campo de tenant no convite/edicao de usuario era texto livre',
    category: 'Frontend',
    description: 'Frontend: fix: campo de tenant no convite/edicao de usuario era texto livre.'
  },
  {
    version: '0.1.233',
    date: '2026-09-24',
    commit: '0210f0a',
    repository: 'Frontend',
    title: 'Merge pull request #3 from Incloud-Tecnologia/feature/gross-cost-credit-visibility',
    category: 'IA',
    description: 'Frontend: Merge pull request #3 from Incloud-Tecnologia/feature/gross-cost-credit-visibility.'
  },
  {
    version: '0.1.233',
    date: '2026-09-23',
    commit: '2b9b638',
    repository: 'Frontend',
    title: 'feat: mostrar custo bruto e credito aplicado no resumo executivo',
    category: 'Frontend',
    description: 'Frontend: feat: mostrar custo bruto e credito aplicado no resumo executivo.'
  },
  {
    version: '0.1.233',
    date: '2026-09-23',
    commit: '984c14b',
    repository: 'Frontend',
    title: 'Merge pull request #2 from Incloud-Tecnologia/feature/tenant-wide-client-access-ui',
    category: 'IA',
    description: 'Frontend: Merge pull request #2 from Incloud-Tecnologia/feature/tenant-wide-client-access-ui.'
  },
  {
    version: '0.1.233',
    date: '2026-09-22',
    commit: '7c0b689',
    repository: 'Frontend',
    title: 'feat: esconder acoes de gerenciamento de conta pra perfil de cliente',
    category: 'IA',
    description: 'Frontend: feat: esconder acoes de gerenciamento de conta pra perfil de cliente.'
  },
  {
    version: '0.1.233',
    date: '2026-09-14',
    commit: '47d5c9a',
    repository: 'Frontend',
    title: 'feat: UI pra gerenciar destinatarios do relatorio executivo recorrente',
    category: 'IA',
    description: 'Frontend: feat: UI pra gerenciar destinatarios do relatorio executivo recorrente.'
  },
  {
    version: '0.1.233',
    date: '2026-09-14',
    commit: 'dc61bdc',
    repository: 'Frontend',
    title: 'feat: tela de gestao de recomendacoes para o time interno',
    category: 'Frontend',
    description: 'Frontend: feat: tela de gestao de recomendacoes para o time interno.'
  },
  {
    version: '0.1.233',
    date: '2026-09-08',
    commit: '96080ac',
    repository: 'Frontend',
    title: 'fix(ci): adicionar concurrency ao workflow de deploy do frontend',
    category: 'Frontend',
    description: 'Frontend: fix(ci): adicionar concurrency ao workflow de deploy do frontend.'
  },
  {
    version: '0.1.233',
    date: '2026-09-02',
    commit: 'd83ae69',
    repository: 'Frontend',
    title: 'fix: corrigir demais achados da auditoria do relatorio executivo',
    category: 'IA',
    description: 'Frontend: fix: corrigir demais achados da auditoria do relatorio executivo.'
  },
  {
    version: '0.1.233',
    date: '2026-09-02',
    commit: 'ef39925',
    repository: 'Frontend',
    title: 'fix: remover card hero \'Visao Geral de Custos\' da Visao Geral de Custos',
    category: 'Frontend',
    description: 'Frontend: fix: remover card hero \'Visao Geral de Custos\' da Visao Geral de Custos.'
  },
  {
    version: '0.1.233',
    date: '2026-09-02',
    commit: '4301d89',
    repository: 'Frontend',
    title: 'feat: adicionar card \'Mes Anterior\' na Visao Geral de Custos',
    category: 'Frontend',
    description: 'Frontend: feat: adicionar card \'Mes Anterior\' na Visao Geral de Custos.'
  },
  {
    version: '0.1.233',
    date: '2026-09-02',
    commit: 'b21642a',
    repository: 'Frontend',
    title: 'fix: aplicar achados da auditoria de responsividade do relatorio executivo',
    category: 'IA',
    description: 'Frontend: fix: aplicar achados da auditoria de responsividade do relatorio executivo.'
  },
  {
    version: '0.1.233',
    date: '2026-09-02',
    commit: '66a68a3',
    repository: 'Frontend',
    title: 'fix: grid da Visao Geral de Custos com 3 cards fixos por linha',
    category: 'Frontend',
    description: 'Frontend: fix: grid da Visao Geral de Custos com 3 cards fixos por linha.'
  },
  {
    version: '0.1.233',
    date: '2026-09-02',
    commit: '4a1ea6b',
    repository: 'Frontend',
    title: 'feat: adicionar card \'Custo Total do Periodo\' na Visao Geral de Custos',
    category: 'Frontend',
    description: 'Frontend: feat: adicionar card \'Custo Total do Periodo\' na Visao Geral de Custos.'
  },
  {
    version: '0.1.233',
    date: '2026-09-02',
    commit: 'dc45ec0',
    repository: 'Frontend',
    title: 'fix: usar Container Queries para o tamanho da fonte dos cards de metrica',
    category: 'IA',
    description: 'Frontend: fix: usar Container Queries para o tamanho da fonte dos cards de metrica.'
  },
  {
    version: '0.1.233',
    date: '2026-09-01',
    commit: '1b64263',
    repository: 'Frontend',
    title: 'fix: usar percentual/ranking corrigidos do backend e corrigir overflow em resolucoes menores',
    category: 'Backend',
    description: 'Frontend: fix: usar percentual/ranking corrigidos do backend e corrigir overflow em resolucoes menores.'
  },
  {
    version: '0.1.233',
    date: '2026-09-01',
    commit: 'ede87a6',
    repository: 'Frontend',
    title: 'fix: remover variavel \'keys\' nao utilizada em pickTemporalSeries',
    category: 'IA',
    description: 'Frontend: fix: remover variavel \'keys\' nao utilizada em pickTemporalSeries.'
  },
  {
    version: '0.1.233',
    date: '2026-09-01',
    commit: 'ba5a0c2',
    repository: 'Frontend',
    title: 'fix: aplicar \'Ultimo Mes Fechado\' tambem na tabela de Top Projetos por Custo',
    category: 'Frontend',
    description: 'Frontend: fix: aplicar \'Ultimo Mes Fechado\' tambem na tabela de Top Projetos por Custo.'
  },
  {
    version: '0.1.233',
    date: '2026-09-01',
    commit: '1d220e6',
    repository: 'Frontend',
    title: 'fix: corrigir custos exibidos em \'Top Servicos por Custo\' para nao somar o periodo inteiro',
    category: 'Frontend',
    description: 'Frontend: fix: corrigir custos exibidos em \'Top Servicos por Custo\' para nao somar o periodo inteiro.'
  },
  {
    version: '0.1.233',
    date: '2026-09-01',
    commit: 'a7216cd',
    repository: 'Frontend',
    title: 'fix: travar overflow-y para eliminar barra de rolagem vertical fantasma',
    category: 'Frontend',
    description: 'Frontend: fix: travar overflow-y para eliminar barra de rolagem vertical fantasma.'
  },
  {
    version: '0.1.233',
    date: '2026-08-31',
    commit: '089184a',
    repository: 'Frontend',
    title: 'fix: remover min-height fixo do card de Relatórios por conta',
    category: 'Frontend',
    description: 'Frontend: fix: remover min-height fixo do card de Relatórios por conta.'
  },
  {
    version: '0.1.233',
    date: '2026-08-31',
    commit: 'a9814a4',
    repository: 'Frontend',
    title: 'fix: fixar coluna Ações à direita nas tabelas de Contas Conectadas e Relatórios',
    category: 'Frontend',
    description: 'Frontend: fix: fixar coluna Ações à direita nas tabelas de Contas Conectadas e Relatórios.'
  },
  {
    version: '0.1.233',
    date: '2026-08-31',
    commit: '2f77da0',
    repository: 'Frontend',
    title: 'fix: remover max-height/overflow:hidden que travava o card de Contas Conectadas',
    category: 'Frontend',
    description: 'Frontend: fix: remover max-height/overflow:hidden que travava o card de Contas Conectadas.'
  },
  {
    version: '0.1.233',
    date: '2026-08-31',
    commit: '89f3060',
    repository: 'Frontend',
    title: 'feat(gcp): campo de correção de faturamento por conta no modal (platform-admin)',
    category: 'Frontend',
    description: 'Frontend: feat(gcp): campo de correção de faturamento por conta no modal (platform-admin).'
  },
  {
    version: '0.1.233',
    date: '2026-08-31',
    commit: 'd605bab',
    repository: 'Frontend',
    title: 'feat(gcp): esconder correção de faturamento (%) de quem não é platform-admin',
    category: 'Frontend',
    description: 'Frontend: feat(gcp): esconder correção de faturamento (%) de quem não é platform-admin.'
  },
  {
    version: '0.1.233',
    date: '2026-08-31',
    commit: '1662856',
    repository: 'Frontend',
    title: 'fix: correção de faturamento GCP por tenant + rótulo/oculta linha de moeda zerada',
    category: 'Frontend',
    description: 'Frontend: fix: correção de faturamento GCP por tenant + rótulo/oculta linha de moeda zerada.'
  },
  {
    version: '0.1.233',
    date: '2026-08-31',
    commit: 'eb3177b',
    repository: 'Frontend',
    title: 'feat(gcp): campo "Correção de faturamento (%)" no modal de edição de conta',
    category: 'Frontend',
    description: 'Frontend: feat(gcp): campo "Correção de faturamento (%)" no modal de edição de conta.'
  },
  {
    version: '0.1.233',
    date: '2026-08-25',
    commit: '35762a7',
    repository: 'Frontend',
    title: 'Revert "fix(gcp): avisar que Média Mensal/Mês Atual não são a fatura oficial"',
    category: 'IA',
    description: 'Frontend: Revert "fix(gcp): avisar que Média Mensal/Mês Atual não são a fatura oficial".'
  },
  {
    version: '0.1.233',
    date: '2026-08-25',
    commit: 'a02073c',
    repository: 'Frontend',
    title: 'fix(gcp): avisar que Média Mensal/Mês Atual não são a fatura oficial',
    category: 'IA',
    description: 'Frontend: fix(gcp): avisar que Média Mensal/Mês Atual não são a fatura oficial.'
  },
  {
    version: '0.1.233',
    date: '2026-08-25',
    commit: 'd85c978',
    repository: 'Frontend',
    title: 'fix(frontend): loading spinner correto e drilldown por período na Média Mensal',
    category: 'IA',
    description: 'Frontend: fix(frontend): loading spinner correto e drilldown por período na Média Mensal.'
  },
  {
    version: '0.1.233',
    date: '2026-08-24',
    commit: 'be8a2c0',
    repository: 'Frontend',
    title: 'feat(gcp): card "Mês Atual (Projeção)" no relatório executivo',
    category: 'Frontend',
    description: 'Frontend: feat(gcp): card "Mês Atual (Projeção)" no relatório executivo.'
  },
  {
    version: '0.1.233',
    date: '2026-08-24',
    commit: '8d1a9ee',
    repository: 'Frontend',
    title: 'fix(gcp): não deixar economia estratégica (benchmark) sobrescrever a economia oficial no relatório',
    category: 'IA',
    description: 'Frontend: fix(gcp): não deixar economia estratégica (benchmark) sobrescrever a economia oficial no relatório.'
  },
  {
    version: '0.1.233',
    date: '2026-08-20',
    commit: '12dfdc2',
    repository: 'Frontend',
    title: 'fix: stop nested scrollbars on /reports grouped tables',
    category: 'Frontend',
    description: 'Frontend: fix: stop nested scrollbars on /reports grouped tables.'
  },
  {
    version: '0.1.233',
    date: '2026-08-20',
    commit: '72c7618',
    repository: 'Frontend',
    title: 'docs: GCP now has recommendation tracking, only Azure\'s footnote remains',
    category: 'IA',
    description: 'Frontend: docs: GCP now has recommendation tracking, only Azure\'s footnote remains.'
  },
  {
    version: '0.1.233',
    date: '2026-08-20',
    commit: 'b1705c2',
    repository: 'Frontend',
    title: 'docs: update "economia implementada" card copy for auto-detection',
    category: 'IA',
    description: 'Frontend: docs: update "economia implementada" card copy for auto-detection.'
  },
  {
    version: '0.1.233',
    date: '2026-08-20',
    commit: '59d602f',
    repository: 'Frontend',
    title: 'fix: home table shows account before cloud, groups accounts by client',
    category: 'Frontend',
    description: 'Frontend: fix: home table shows account before cloud, groups accounts by client.'
  },
  {
    version: '0.1.233',
    date: '2026-08-18',
    commit: '52befb6',
    repository: 'Frontend',
    title: 'fix: home page always scopes to the user\'s own tenant',
    category: 'Frontend',
    description: 'Frontend: fix: home page always scopes to the user\'s own tenant.'
  },
  {
    version: '0.1.233',
    date: '2026-08-18',
    commit: '3954cd0',
    repository: 'Frontend',
    title: 'fix: prefer backend-computed averageMonthlyCost for top services/projects',
    category: 'Backend',
    description: 'Frontend: fix: prefer backend-computed averageMonthlyCost for top services/projects.'
  }
];

export default generatedReleaseNotes;
